export default "__VITE_ASSET__DsmlWAFm__"